import './Story.css';
import { useParams, Link } from 'react-router-dom';
import storyList from './stories/storyList.js'
import Footer from './Footer.js';
import React from "react";

function Story(props) {
    let params = useParams();

    let storySelected = storyList.find ((story) =>
    story.shortName === params.storyShortName)

    if (typeof storySelected === "undefined") {
        return (
            <div className="notValid">
                <Link className="link" to="/" >
                                <p className="backButton"> back to home </p>
                            </Link>
                <p className="notValidText"> {params.storyShortName} is not a valid story</p>
            </div>
        )
    }
    else 
    return (
        <div className="story">
            <Link className="link" to="/" >
                <p className="backButton"> back to home </p>
            </Link>
            <h1 className="storyHeaderText"> {storySelected.title}</h1>
            {storySelected.story.map((element, index) => (
                <div>
                {element}
                </div>
            ))}
        <Footer/>
        </div>

    )

}

export default Story;